function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.021 1.7v4.145a3.317 3.317 0 11-1.967-.025V1.69A7.373 7.373 0 009 16.372 7.373 7.373 0 0016.372 9a7.37 7.37 0 00-6.35-7.3z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 18c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zM9 .768C4.46.768.768 4.461.768 9c0 4.54 3.693 8.232 8.232 8.232 4.54 0 8.232-3.693 8.232-8.232C17.232 4.46 13.539.768 9 .768z",
  fill: "#000"
})));